import React, {useEffect} from 'react';

import KKMControl from './KKMControl/KKMControl';
import './kkm-control.css';
import {Alert, AlertTitle} from '@mui/material';

interface IKKMControlContainer {
    setCurrentPageClass: React.Dispatch<React.SetStateAction<string>>;
    userId: number | null;
}

const KKMControlContainer = (props: IKKMControlContainer) => {
    const {setCurrentPageClass, userId} = props;

    useEffect(() => {
        setCurrentPageClass('bg kkm');
    });

    return (
        <section className={'content'}>
            <div className={'header'}>
                <h1 className={'title'}>
                    <span>Клиенты и кассы</span>
                </h1>
            </div>
            <div className={'workspace'}>
                {/*<Alert*/}
                {/*    severity="warning"*/}
                {/*    sx={{*/}
                {/*        marginLeft: '-15px',*/}
                {/*        marginRight: '-15px',*/}
                {/*        '& .MuiAlert-icon': {*/}
                {/*            color: 'warning.main',*/}
                {/*        },*/}
                {/*    }}*/}
                {/*>*/}
                {/*    <AlertTitle>Внимание!</AlertTitle>*/}
                {/*    <p>*/}
                {/*        В связи с переходом на новую ставку НДС платежи на сервисе ПОРТall приниматься не будут с{' '}*/}
                {/*        <strong>16:00 30 декабря 2025 г. по 9 января 2026 г. включительно.</strong><br />*/}
                {/*        При этом кассы блокироваться не будут и продолжат работу до <strong>15 января 2026 г.</strong><br />*/}
                {/*        Кассы, созданные в период с <strong>1 по 15 января 2026 г.</strong>, будут работать без оплаты до{' '}*/}
                {/*        <strong>15 января 2026 г. включительно.</strong><br />*/}
                {/*        Подробная информация будет предоставлена на зуминарах. Следите за новостями в чате WhatsApp{' '}*/}
                {/*        <strong>«ПОРТ & Партнёры».</strong>.*/}
                {/*    </p>*/}
                {/*</Alert>*/}
                {new Date() < new Date('2026-11-01') && (
                    <Alert
                        severity="warning"
                        sx={{
                            marginLeft: '-15px',
                            marginRight: '-15px',
                            '& .MuiAlert-icon': {
                                color: 'warning.main',
                            },
                        }}
                    >
                        <AlertTitle>Внимание!</AlertTitle>
                        <p>
                            С <strong>1 октября 2026 г.</strong> действуют тарифы: тариф «Прокси» (связь с любым ОФД) –{' '}
                            <strong>1015 ₸/мес с НДС</strong> за кассу, тариф «Номенклатура» – дополнительно <strong>1015 ₸/мес с НДС</strong>{' '}
                            (итого 2030 ₸/мес, как раньше).
                            {/*<br />*/}
                            {/*Оплатить можно уже сейчас: в разделе «Оплата» такие кассы показывают новую цену с пометкой{' '}*/}
                            {/*<strong>«с 01.10.2026»</strong>.*/}
                            {/*<br />*/}
                            {/*Во избежание блокировки касс рекомендуем внести оплату до <strong>6 октября 2026 г.</strong>*/}
                        </p>
                    </Alert>
                )}
                <KKMControl userId={userId} />
            </div>
        </section>
    );
};

export default KKMControlContainer;
